<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-房间管理-添加
    -->
    <el-dialog
    title="添加房间管理"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加房间管理</div>

      <el-form-item label="房间号" prop="room_number"><el-input v-model="form.room_number" placeholder="请输入房间号" class="max-w460"></el-input></el-form-item>
      
      <el-form-item label="位置" prop="location"><el-input v-model="form.location" placeholder="请输入位置" class="max-w460"></el-input></el-form-item>
      
      <el-form-item label="备注" prop="remark"><el-input v-model="form.remark" placeholder="请输入备注" type="textarea" class="max-w460"></el-input></el-form-item>
      
      <el-form-item label="选择商家" prop="supply_id">
        <el-select v-model="form.supply_id" placeholder="请选择商家" class="max-w460">
          <el-option v-for="item in supplyList" :key="item.supply_id" :label="item.name" :value="item.supply_id"></el-option>
        </el-select>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>
  
</template>

<script>
import FangjianApi from '@/api/fangjian.js';
import SupplyApi from '@/api/supply.js';

export default {
  components: {
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        room_number: '',
        location: '',
        remark: '',
        supply_id: ''
      },
      loading: false,
      /*验证规则*/
      rules: {
        room_number: [{ required: true, message: '请输入房间号', trigger: 'blur' }],
        supply_id: [{ required: true, message: '请选择商家', trigger: 'change' }]
      },
      dialogVisible: false,
      supplyList: []
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getSupplyList();
  },
  props: ["open_add"],
  methods: {
    /*获取商家列表*/
    getSupplyList() {
      let self = this;
      SupplyApi.supplyList({}, true)
        .then(data => {
          self.supplyList = data.data.list.data;
        })
        .catch(error => {
          console.error('获取商家列表失败:', error);
        });
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    
    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    
    onSubmit() {
      let self = this;
      let form = self.form;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          FangjianApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/fangjian/index/part/add.vue